import { BlackFridayBanner } from '@fiverr-private/black_friday_banner';

export default BlackFridayBanner;
